import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

import {
	AddRounded,
	DeleteOutlineRounded,
	DoneRounded,
	EditRounded,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import TextInputField from "../reusable/TextInputField";
import ControlContext from "../../context/ControlContext";
import { useContext } from "react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		padding: 0,
		textAlign: "center",
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		padding: 0,
		textAlign: "center",
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

const ScrapSalesTable = ({ setgridValues, gridValues }) => {
	let defaultSalesRecord = {
		serial: "",
		itemCode: "",
		itemDesc: "",
		purity: "",
		qty: "",
		grossWgt: "",
		ded: "",
		dedWgt: "",
		netWgt: "",
		pureWgt: "",
		rateGm: "",
		totalAmount: "",
	};

	let [salesRecord, setSalesRecord] = useState(defaultSalesRecord);

	//  onChange function for the form values
	const handleChange = (prop) => (event) => {
		setSalesRecord({ ...salesRecord, [prop]: event.target.value });
	};

	let [editting, setEditting] = useState(false);
	let {
		handleAddRecord,
		handleDeleteRecord,
		handleEditRecord,
		handleSaveEdit,
	} = useContext(ControlContext);

	useEffect(() => {
		console.log(gridValues.length);
	}, []);

	return (
		<TableContainer
			sx={{ height: 180, border: "1px solid gray", borderRadius: "5px" }}
		>
			<Table>
				<TableHead>
					<TableRow>
						<StyledTableCell>S#</StyledTableCell>
						<StyledTableCell> ItemCode</StyledTableCell>
						<StyledTableCell>ItemDesc</StyledTableCell>
						<StyledTableCell>Purity</StyledTableCell>
						<StyledTableCell>Qty</StyledTableCell>
						<StyledTableCell>Gross Wgt</StyledTableCell>
						<StyledTableCell>Ded(%)</StyledTableCell>
						<StyledTableCell>Ded Wgt</StyledTableCell>
						<StyledTableCell>Net Wgt</StyledTableCell>
						<StyledTableCell>Pure Wgt</StyledTableCell>
						<StyledTableCell>Rate Gm</StyledTableCell>
						<StyledTableCell>TotalAmount</StyledTableCell>
						<StyledTableCell></StyledTableCell>
					</TableRow>
					<TableRow>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.serial}
								onChange={handleChange("serial")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemCode}
								onChange={handleChange("itemCode")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemDesc}
								onChange={handleChange("itemDesc")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.purity}
								onChange={handleChange("purity")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.qty}
								onChange={handleChange("qty")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.grossWgt}
								onChange={handleChange("grossWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.ded}
								onChange={handleChange("ded")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.dedWgt}
								onChange={handleChange("dedWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.netWgt}
								onChange={handleChange("netWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.pureWgt}
								onChange={handleChange("pureWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.rateGm}
								onChange={handleChange("rateGm")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.totalAmount}
								onChange={handleChange("totalAmount")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							{!editting ? (
								<IconButton
									onClick={() =>
										handleAddRecord(
											setSalesRecord,
											gridValues,
											setgridValues,
											salesRecord,
											defaultSalesRecord
										)
									}
									color="primary"
									component="label"
								>
									<AddRounded />
								</IconButton>
							) : (
								<IconButton
									onClick={() =>
										handleSaveEdit(
											salesRecord.itemCode,
											setSalesRecord,
											gridValues,
											salesRecord,
											defaultSalesRecord,
											setgridValues,
											setEditting
										)
									}
									color="primary"
									component="label"
								>
									<DoneRounded />
								</IconButton>
							)}
						</StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{gridValues.length !== undefined && gridValues.length > 0
						? gridValues.map((row, index) => (
								<StyledTableRow key={index}>
									<StyledTableCell component="th" scope="row">
										{row.serial || index}
									</StyledTableCell>
									<StyledTableCell>{row.itemCode}</StyledTableCell>
									<StyledTableCell>{row.itemDesc}</StyledTableCell>
									<StyledTableCell>{row.purity}</StyledTableCell>
									<StyledTableCell>{row.qty}</StyledTableCell>
									<StyledTableCell>{row.grossWgt}</StyledTableCell>
									<StyledTableCell>{row.ded}</StyledTableCell>
									<StyledTableCell>{row.dedWgt}</StyledTableCell>
									<StyledTableCell>{row.netWgt}</StyledTableCell>
									<StyledTableCell>{row.pureWgt}</StyledTableCell>
									<StyledTableCell>{row.rateGm}</StyledTableCell>
									<StyledTableCell>{row.totalAmount}</StyledTableCell>
									<StyledTableCell
										sx={{ display: "flex", alignItems: "center" }}
									>
										<IconButton
											onClick={() =>
												handleEditRecord(
													row.itemCode,
													setSalesRecord,
													gridValues,
													setEditting
												)
											}
											color="secondary"
											component="label"
										>
											<EditRounded sx={{ fontSize: 14 }} />
										</IconButton>
										<IconButton
											onClick={() =>
												handleDeleteRecord(
													row.itemCode,
													gridValues,
													setgridValues,
													setSalesRecord,
													defaultSalesRecord
												)
											}
											color="error"
											component="label"
										>
											<DeleteOutlineRounded sx={{ fontSize: 14 }} />
										</IconButton>
									</StyledTableCell>
								</StyledTableRow>
						  ))
						: null}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default ScrapSalesTable;
